import { z } from 'zod';

export const ProdutoOrigemSchema = z.object({
    pro_codigo: z.number(),
    pro_descricao: z.string(),
});

export type ProdutoOrigem = z.infer<typeof ProdutoOrigemSchema>;
